import { __env } from '../../envloader';

export const defaultVariables = __env.DASHBOARD_FLAVOUR_NUMBER===1 ? [
  { idsField: 'ids_properties/creation_date', id: 9 },
  { idsField: 'global_quantities/ip/value', id: 56 },
  { idsField: 'global_quantities/b0/value', id: 198 },
  { idsField: 'global_quantities/q_95/value', id: 243 }
] : [
  { idsField: 'ids_properties/creation_date', id: 9  },
  { idsField: 'global_quantities/ip/value', id: 56 },
  { idsField: 'global_quantities/b0/value', id: 198 },
  { idsField: 'global_quantities/q_95/value', id: 243 },
  { idsField: 'global_quantities/power_ohm/value', id: 248 },
];

export const variablesTypes = {
  "INT_0D": { type: 1, value: "integer" },
  "INT_1D": { type: 1, value: "integer" },
  "INT_2D": { type: 1, value: "integer" },
  "INT_3D": { type: 1, value: "integer" },
  "FLT_0D": { type: 2, value: "double" },
  "FLT_1D": { type: 2, value: "double" },
  "FLT_2D": { type: 2, value: "double" },
  "FLT_3D": { type: 2, value: "double" },
  "FLT_4D": { type: 2, value: "double" },
  "FLT_5D": { type: 2, value: "double" },
  "FLT_6D": { type: 2, value: "double" },
  "COMPLEX": { type: 3, value: "complex" },
  "STR_0D": { type: 4, value: "string" },
  "STR_1D": { type: 4, value: "string" },
};

export const idsTypeIds = {
  simulation: 0,
  experimental_data: 1,
  pedestal: 2,
};
